import { motion, AnimatePresence } from 'framer-motion';
import { useStoryStore } from '../../store/storyStore';
import { ChoiceButton } from './ChoiceButton';

/**
 * ChoicePanel component
 * Displays available player choices
 */
export function ChoicePanel() {
  const availableChoices = useStoryStore((state) => state.availableChoices);
  const isChoicePanelVisible = useStoryStore((state) => state.isChoicePanelVisible);
  const selectChoice = useStoryStore((state) => state.selectChoice);

  if (!isChoicePanelVisible || availableChoices.length === 0) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="choice-panel fixed bottom-40 sm:bottom-48 left-0 right-0 mx-auto w-[calc(100%-1.5rem)] sm:w-[calc(100%-3rem)] md:w-full max-w-3xl px-0 sm:px-0 md:px-8 z-[110]"
      >
        <div className="flex flex-col gap-2 sm:gap-3">
          {availableChoices.map((choice, index) => (
            <ChoiceButton
              key={choice.id}
              choice={choice}
              onClick={selectChoice}
              index={index}
            />
          ))}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
